import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import isLoggedIn from "./utils/isLoggedIn";
import Layout from "./layout/Layout";
import AuthGuard from "./layout/guards/Auth";
import PSMGuard from "./layout/guards/PSMGuard";
import RECGuard from "./layout/guards/RECGuard";
import OUTGuard from "./layout/guards/OUTGuard";
import SALGuard from "./layout/guards/Sales";
import OutsourcedGuard from "./layout/guards/Outsourced";

// public
import JobApplication from "./pages/public/JobApplication";
import Jobs from "./pages/public/Jobs";

// auth
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/Forgot";

// organization
import Landing from "./pages/dashboard/Landing";
import Profile from "./pages/dashboard/Profile";
import Notifications from "./pages/dashboard/Notifications";
import MyAttendance from "./pages/dashboard/MyAttendance";
import Password from "./pages/dashboard/MyPassword";

import CompanyProfile from "./pages/organization/Profile";
import CompanyDepartments from "./pages/organization/Departments";
import CompanyBranches from "./pages/organization/Branches"

// leave
import LeaveRequests from "./pages/leave/LeaveRequests";
import ApplyForLeave from "./pages/leave/ApplyForLeave";
import ViewLeave from "./pages/leave/ViewLeave";
// import LeaveReports from "./pages/leave/LeaveReports";
import LeaverTracker from "./pages/leave//LeaverTracker";


// psm people
import Employees from "./pages/people/Employees";
import ViewEmployee from "./pages/people/ViewEmployee";
import AssignRoles from "./pages/people/AssignRoles";
import AllAttendance from "./pages/people/AllAttendance";
import AttendanceReport from "./pages/people/AttendanceReport";

// psm hiring
import Hiring from "./pages/hiring/Hiring";
import NewEmployee from "./pages/hiring/NewEmployee";
import ImportEmployees from "./pages/hiring/ImportEmployees";
import SendInvite from "./pages/hiring/SendInvite";


// performance
// import KPDs from "./pages/performance/KPDs";
// import AddKPI from "./pages/performance/AddKPI";
// import KPIs from "./pages/performance/KPIs";
// import ViewKPD from "./pages/performance/ViewKPD";
// import AddKPD from "./pages/performance/AddKPD";
import Appraisals from "./pages/performance/Appraisals";
import NewAppraisal from "./pages/performance/NewAppraisal";
import Tasks from "./pages/performance/Tasks";
import AddTask from "./pages/performance/AddTask";
import ViewTask from "./pages/performance/ViewTask";

// recruitment
import JobOpenings from "./pages/recruitment/JobOpenings";
import AddJob from "./pages/recruitment/AddJob";
import ViewJobOpening from "./pages/recruitment/ViewJobOpening";
import JobApplicants from "./pages/recruitment/JobApplicants";
import EditJobOpening from "./pages/recruitment/EditJobOpening";

// outsourcing
import Organizations from "./pages/outsourcing/Organizations";
import ViewOrganization from "./pages/outsourcing/ViewOrganization";
import OutsourcingEmployees from "./pages/outsourcing/Employees";
import OutsourcingOnboarding from "./pages/outsourcing/Onboarding";
import OnboardEmployees from "./pages/outsourcing/OnboardEmployees";
import OutsourcingLearning from "./pages/outsourcing/Learning";
import OutsourcingLeaves from "./pages/outsourcing/Leaves";
import OutsourcingEmployeeAdd from "./pages/outsourcing/EmployeeAdd";
import ViewLearning from "./pages/outsourcing/ViewLearning";

// sales
import SalesHome from "./pages/sales/Home";
import Customers from "./pages/sales/Customers";
import Sectors from "./pages/sales/Sectors";
import Contacts from "./pages/sales/Contacts";
import Leads from "./pages/sales/Leads";
import Calls from "./pages/sales/Calls";
import ViewLead from "./pages/sales/ViewLead";

// outsourced staff
import MyProfile from "./pages/outsourced/MyProfile";
import MyOnboarding from "./pages/outsourced/MyOnboarding";
import MyPassword from "./pages/outsourced/MyPassword";
import MyLearning from "./pages/outsourced/MyLearning";
import MyLeaves from "./pages/outsourced/MyLeaves";



import "./App.css";
import "react-alice-carousel/lib/alice-carousel.css";
import "react-multi-carousel/lib/styles.css";


function App() {
  return (
    <Router>
      
      <>
        {isLoggedIn() ? 
          <Layout>
          <Switch>
            
            <Route exact path={"/dashboard"}><Landing /></Route>
            <AuthGuard exact path={"/notifications"}> <Notifications /></AuthGuard>
            <AuthGuard exact path={"/profile"} ><Profile/></AuthGuard>
            <AuthGuard exact path={"/password"} ><Password /></AuthGuard>
            <AuthGuard exact path={"/attendance/records"} ><MyAttendance /></AuthGuard>

            <AuthGuard exact path={"/company-profile"} ><CompanyProfile /></AuthGuard>
            <AuthGuard exact path={"/company-departments"} ><CompanyDepartments/></AuthGuard>
            <AuthGuard exact path={"/company-branches"} ><CompanyBranches/></AuthGuard>
            
            <PSMGuard exact path={"/employees"}><Employees /></PSMGuard>
            <PSMGuard exact path={"/employee/:id/view"}><ViewEmployee /></PSMGuard>
            <PSMGuard exact path={"/admin/roles"} ><AssignRoles /></PSMGuard>
            <PSMGuard exact path={"/hiring"} ><Hiring /></PSMGuard>
            <PSMGuard exact path={"/hiring/new-employee"} ><NewEmployee /></PSMGuard>
            <PSMGuard exact path={"/hiring/import-employees"} ><ImportEmployees /></PSMGuard>
            <PSMGuard exact path={"/hiring/invite-link"} ><SendInvite /></PSMGuard>
            <PSMGuard exact path={"/attendance/report"} ><AttendanceReport /></PSMGuard>
            <PSMGuard exact path={"/attendance/all"} ><AllAttendance /></PSMGuard>
            <PSMGuard exact path={"/leave/tracker"} ><LeaverTracker /></PSMGuard>
            {/* <PSMGuard exact path={"/leave/reports"} ><LeaveReports /></PSMGuard> */}
            {/* <PSMGuard exact path={"/performance/kpd-add"} ><AddKPD /></PSMGuard> */}
            {/* <PSMGuard exact path={"/performance/kpi-add"} ><AddKPI /></PSMGuard> */}
            
            {/* <AuthGuard exact path={"/performance/kpds"} ><KPDs /></AuthGuard> */}
            {/* <AuthGuard exact path={"/performance/kpis"} ><KPIs /></AuthGuard> */}
            {/* <AuthGuard exact path={"/performance/kpd/:id"} ><ViewKPD /></AuthGuard> */}
            <AuthGuard exact path={"/performance/appraisals"} ><Appraisals /></AuthGuard>
            <AuthGuard exact path={"/performance/newappraisal"} ><NewAppraisal /></AuthGuard>
            <AuthGuard exact path={"/performance/tasks"} ><Tasks /></AuthGuard>
            <AuthGuard exact path={"/performance/create-task"} ><AddTask /></AuthGuard>
            <AuthGuard exact path={"/performance/task/:id"} ><ViewTask /></AuthGuard>
            
            <RECGuard exact path={"/recruitment/jobs"} ><JobOpenings /></RECGuard>
            <RECGuard exact path={"/recruitment/job/post"} ><AddJob /></RECGuard>
            <RECGuard exact path={"/recruitment/job/overview/:id"} ><ViewJobOpening /></RECGuard>
            <RECGuard exact path={"/recruitment/job/:id/applicants"} ><JobApplicants /></RECGuard>
            <RECGuard exact path={"/recruitment/job/:id/edit"} ><EditJobOpening /></RECGuard>
            
            <AuthGuard exact path={"/leave/requests"} ><LeaveRequests /></AuthGuard>
            <AuthGuard exact path={"/leave/request/:id"} ><ViewLeave /></AuthGuard>
            <AuthGuard exact path={"/leave/apply"} ><ApplyForLeave /></AuthGuard>

            <OUTGuard exact path={"/outsourcing/organizations"} ><Organizations /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/organization/:id"} ><ViewOrganization /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/employees"} ><OutsourcingEmployees /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/employees/add"} ><OutsourcingEmployeeAdd /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/onboarding"} ><OutsourcingOnboarding /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/learning"} ><OutsourcingLearning /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/townhall/:id"} ><ViewLearning /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/leaves"} ><OutsourcingLeaves /></OUTGuard>
            <OUTGuard exact path={"/outsourcing/onboard"} ><OnboardEmployees /></OUTGuard>

            <SALGuard exact path={"/sales"} ><SalesHome /></SALGuard>
            <SALGuard exact path={"/sales/customers"} ><Customers /></SALGuard>
            <SALGuard exact path={"/sales/sectors"} ><Sectors /></SALGuard>
            <SALGuard exact path={"/sales/contacts"} ><Contacts /></SALGuard>
            <SALGuard exact path={"/sales/leads"} ><Leads /></SALGuard>
            <SALGuard exact path={"/sales/calls"} ><Calls /></SALGuard>
            <SALGuard exact path={"/sales/lead/:id"} ><ViewLead /></SALGuard>


            <OutsourcedGuard exact path={"/my/profile"}><MyProfile /></OutsourcedGuard>
            <OutsourcedGuard exact path={"/my/onboarding"}><MyOnboarding /></OutsourcedGuard>
            <OutsourcedGuard exact path={"/my/learning"}><MyLearning /></OutsourcedGuard>
            <OutsourcedGuard exact path={"/my/leave"}><MyLeaves /></OutsourcedGuard>
            <OutsourcedGuard exact path={"/my/appraisals"}><MyLearning /></OutsourcedGuard>
            <OutsourcedGuard exact path={"/my/password"}><MyPassword /></OutsourcedGuard>

            <Redirect to={"/dashboard"} />

          </Switch>
        </Layout>
        : <>
          <Switch>
            <Route exact path={"/"} component={Login} />
            <Route exact path={"/forgot-password"} component={ForgotPassword} />
            <Route exact path={"/public/job/overview/:id"} component={JobApplication}></Route>
            <Route exact path={"/public/jobs"} component={Jobs}></Route>
            
            <Redirect to={"/"} />   

            </Switch>
          </>
        }
        </>

    </Router>
  );
}

export default App;
